import { useEffect, useState } from "react";

//Util
import { ICONES_MENSAGEM } from "@/frontend/utils/icones";
import {
  fn_isManutencaoAtiva,
  fn_onAlteracaoManutencao,
} from "@/frontend/utils/manutencao";

/*
 * Tarja de aviso do bloqueio de manutenção ligado.
 * Aparece só para o usuário system / system_dev, que continua usando o sistema durante a manutenção
 * (o servidor só envia a indicação nas respostas dele). Some quando o bloqueio for desligado.
 */
export default function AvisoManutencao() {
  //### USE STATE ###
  const [manutencaoAtiva, setManutencaoAtiva] = useState(
    fn_isManutencaoAtiva(),
  );

  //### USE EFFECT ###
  //Acompanha o bloqueio de manutenção informado nas respostas do servidor
  useEffect(() => {
    return fn_onAlteracaoManutencao(() =>
      setManutencaoAtiva(fn_isManutencaoAtiva()),
    );
  }, []);

  if (!manutencaoAtiva) {
    return null;
  }

  return (
    <div className="aviso-manutencao" role="alert">
      <span className="me-2">{ICONES_MENSAGEM.AVISO}</span>
      <strong className="me-1">SISTEMA EM MANUTENÇÃO</strong>
      <span>- Os usuários estão bloqueados.</span>
    </div>
  );
}
